"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.GTM = exports.pushToGTMDataLayer = exports.isDataLayerSet = exports.FormChannel = exports.NewsLetterAction = exports.FormActionEnum = exports.GTMEventEnum = void 0;
var tslib_1 = require("tslib");
var Forms_1 = require("../Views/Partials/Components/Forms");
var Tile_1 = require("../Views/Partials/Components/Tile");
var constants_1 = require("../Views/Partials/Components/UmbracoFormsCustomComponents/constants");
var GTMEventEnum;
(function (GTMEventEnum) {
    GTMEventEnum["NewsLetter"] = "newsletterSignup";
    GTMEventEnum["Form"] = "form";
    GTMEventEnum["IPaper"] = "ipaper";
    GTMEventEnum["Print"] = "print";
    GTMEventEnum["Download"] = "download";
    GTMEventEnum["SocialLink"] = "socialLink";
    GTMEventEnum["Application"] = "application";
    GTMEventEnum["ExitLink"] = "exitLink";
    GTMEventEnum["Filter"] = "filter";
    GTMEventEnum["Search"] = "internal_search";
    GTMEventEnum["PMPLink"] = "CTAButtonClick";
    GTMEventEnum["Navigation"] = "navigation";
    GTMEventEnum["MegaMenu"] = "mega menu";
    GTMEventEnum["SearchResultLink"] = "internal_search_click";
    GTMEventEnum["ContactsListLocationFinderChange"] = "inputLocation";
    GTMEventEnum["ContactListItemClick"] = "contactListClick";
    GTMEventEnum["ContactDetailsDialClick"] = "clickToDial";
    GTMEventEnum["ContactDetailsCustomAttributesClick"] = "clickToCustomAttributes";
    GTMEventEnum["ContactFormOpen"] = "virtualPageView";
    GTMEventEnum["ContactFormLoadError"] = "formLoadError";
    GTMEventEnum["ProductListItemClick"] = "productListClick";
    GTMEventEnum["ProductPageTabClick"] = "productPageTabClick";
    GTMEventEnum["Social"] = "socialClick";
    GTMEventEnum["YoutubeVideo"] = "video";
    GTMEventEnum["FormRedirect"] = "contactUsFormServiceProcessRedirect";
})(GTMEventEnum || (exports.GTMEventEnum = GTMEventEnum = {}));
var FormActionEnum;
(function (FormActionEnum) {
    FormActionEnum["submit"] = "Click to Submit";
    FormActionEnum["success"] = "Success";
    FormActionEnum["errorBE"] = "Back-end error";
    FormActionEnum["errorFE"] = "Front-end validation error";
    FormActionEnum["abandon"] = "Abandon";
    FormActionEnum["viewCustomForm"] = "View Custom Form";
})(FormActionEnum || (exports.FormActionEnum = FormActionEnum = {}));
var NewsLetterAction;
(function (NewsLetterAction) {
    NewsLetterAction["open"] = "Click to Open Form";
    NewsLetterAction["success"] = "Success";
    NewsLetterAction["submit"] = "Click to Submit";
    NewsLetterAction["error"] = "Error";
    NewsLetterAction["abandon"] = "Abandon";
})(NewsLetterAction || (exports.NewsLetterAction = NewsLetterAction = {}));
exports.FormChannel = (_a = {},
    _a[Forms_1.FormTypeEnum.Pardot] = 'Pardot',
    _a[Forms_1.FormTypeEnum.ServiceCloud] = 'Service Cloud',
    _a[Forms_1.FormTypeEnum.Distributors] = 'Distributors',
    _a[Forms_1.FormTypeEnum.DpsDistributors] = 'Custom for DPS Distributors',
    _a[Forms_1.FormTypeEnum.Custom] = 'Custom',
    _a);
var tileListEventMapping = (_b = {},
    _b[Tile_1.TileTypeEnum.SearchResults] = GTMEventEnum.SearchResultLink,
    _b[Tile_1.TileTypeEnum.Product] = GTMEventEnum.ProductListItemClick,
    _b);
var isDataLayerSet = function () {
    return typeof dataLayer !== 'undefined';
};
exports.isDataLayerSet = isDataLayerSet;
var pushToGTMDataLayer = function (obj) {
    if (!(0, exports.isDataLayerSet)()) {
        return;
    }
    dataLayer.push(obj);
};
exports.pushToGTMDataLayer = pushToGTMDataLayer;
var formName = function (formType) {
    return formType === Forms_1.FormTypeEnum.Distributors
        ? exports.FormChannel[formType]
        : "Contact Us - ".concat(exports.FormChannel[formType]);
};
var processUrlRedirection = function (gtmItem, clickEvent, url) {
    var callbackCalled = false;
    var callback = function () {
        if (callbackCalled)
            return;
        callbackCalled = true;
        window.location.href = url;
    };
    clickEvent.preventDefault();
    gtmItem.eventCallback = callback;
    setTimeout(callback, 1000);
};
exports.GTM = {
    /**
     * @param name     - link text
     * @param url      - link href
     * @param redirect - redirect, if link target != _blank
     */
    PMPButton: function (name, url, redirect) {
        if (redirect === void 0) { redirect = false; }
        var called = false;
        var gtmData = {
            buttonName: name,
            buttonURL: url,
            event: GTMEventEnum.PMPLink,
        };
        if (redirect) {
            var callBack = function () {
                if (!called) {
                    window.location.href = url;
                    called = true;
                }
            };
            gtmData.eventCallback = callBack;
            setTimeout(callBack, 1000);
        }
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    customForm: function (currentForm) {
        var _a;
        var customFormName = ((_a = currentForm.find('input[name="FormName"]')) === null || _a === void 0 ? void 0 : _a.val())
            ? currentForm.find('input[name="FormName"]').val()
            : 'Custom Form Name not set';
        var called = false;
        var callback = function () {
            if (!called) {
                called = true;
                currentForm.trigger('submit', [constants_1.formStatuses.processed]);
            }
        };
        exports.GTM.form.submit({ formType: Forms_1.FormTypeEnum.Custom }, customFormName, callback);
        setTimeout(callback, 1000);
    },
    setCustomFormName: function (currentForm) {
        var _a;
        var customFormName = ((_a = currentForm.find('input[name="FormName"]')) === null || _a === void 0 ? void 0 : _a.val())
            ? currentForm.find('input[name="FormName"]').val()
            : 'Custom Form Name not set';
        exports.GTM.form.setStatus({ formType: Forms_1.FormTypeEnum.Custom }, FormActionEnum.viewCustomForm, customFormName);
    },
    download: function (data, callBack) {
        var _a;
        var gtmData = (_a = {
                event: GTMEventEnum.Download
            },
            _a["".concat(GTMEventEnum.Download, "Name")] = data.name,
            _a["".concat(GTMEventEnum.Download, "Path")] = data.path,
            _a["".concat(GTMEventEnum.Download, "Page")] = data.page,
            _a["".concat(GTMEventEnum.Download, "Type")] = data.type,
            _a["".concat(GTMEventEnum.Download, "Category")] = data.category || 'other downloads',
            _a["".concat(GTMEventEnum.Download, "Organization")] = data.organization || 'no organizations',
            _a.segment = data.segment || 'no segments',
            _a);
        var called = false;
        if (callBack) {
            var innerCallBack = function () {
                if (!called) {
                    callBack();
                    called = true;
                }
            };
            gtmData.eventCallback = innerCallBack;
            setTimeout(innerCallBack, 1000);
        }
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    filter: function (filterData) {
        var gtmData = {
            NumberOfResults: filterData.numberOfResults,
            PageName: filterData.pageName,
            event: GTMEventEnum.Filter,
            filterCategory: filterData.filterCategory,
            filterOptions: filterData.filterOptions,
        };
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    form: {
        error: function (_a, isBeError, customFormName, errorField) {
            var formType = _a.formType;
            var errorType = isBeError ? FormActionEnum.errorBE : FormActionEnum.errorFE;
            exports.GTM.form.setStatus({ formType: formType }, errorType, customFormName, errorField);
        },
        setStatus: function (_a, actionType, customFormName, errorField, cb) {
            var _b;
            var formType = _a.formType;
            var isError = actionType === FormActionEnum.errorFE || actionType === FormActionEnum.errorBE;
            var actionLabel = isError ? 'Error' : actionType;
            var gtmData = (_b = {
                    event: GTMEventEnum.Form
                },
                _b["".concat(GTMEventEnum.Form, "Action")] = actionLabel,
                _b["".concat(GTMEventEnum.Form, "Name")] = customFormName || formName(formType),
                _b["".concat(GTMEventEnum.Form, "Type")] = exports.FormChannel[formType],
                _b);
            if (actionType === FormActionEnum.submit && cb) {
                gtmData.eventCallback = cb;
            }
            if (isError) {
                gtmData.ErrorType = actionType;
                !!errorField && (gtmData.ErrorField = errorField);
            }
            (0, exports.pushToGTMDataLayer)(gtmData);
        },
        abandon: function (_a, customFormName) {
            var formType = _a.formType;
            exports.GTM.form.setStatus({ formType: formType }, FormActionEnum.abandon, customFormName);
        },
        submit: function (_a, customFormName, cb) {
            var formType = _a.formType;
            exports.GTM.form.setStatus({ formType: formType }, FormActionEnum.submit, customFormName, null, cb);
        },
        success: function (_a, customFormName) {
            var formType = _a.formType;
            exports.GTM.form.setStatus({ formType: formType }, FormActionEnum.success, customFormName);
        },
        formRedirect: function (item) {
            if (!item.url) {
                return;
            }
            var gtmData = {
                event: GTMEventEnum.FormRedirect,
                formName: item.customFormName || formName(item.formType),
                linkUrl: item.url,
            };
            (0, exports.pushToGTMDataLayer)(gtmData);
        },
    },
    iPaper: function (item) {
        var _a;
        if (!item.name || !item.url) {
            return;
        }
        var gtmData = (_a = {
                event: GTMEventEnum.IPaper
            },
            _a["".concat(GTMEventEnum.IPaper, "Name")] = item.name,
            _a["".concat(GTMEventEnum.IPaper, "URL")] = item.url,
            _a);
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    newsletter: {
        error: function (newsLetterData) {
            exports.GTM.newsletter.setStatus(NewsLetterAction.error, newsLetterData);
        },
        setStatus: function (actionType, newsLetterData) {
            var _a;
            var gtmData = (_a = {
                    event: GTMEventEnum.NewsLetter,
                    newsletterName: newsLetterData.title
                },
                _a["".concat(GTMEventEnum.NewsLetter)] = actionType,
                _a["".concat(GTMEventEnum.NewsLetter, "Control")] = newsLetterData.control,
                _a["".concat(GTMEventEnum.NewsLetter, "Text")] = newsLetterData.label,
                _a);
            if (actionType === NewsLetterAction.error) {
                gtmData.ErrorType = newsLetterData.errorType;
                if (newsLetterData.errorField) {
                    gtmData.ErrorField = newsLetterData.errorField;
                }
            }
            (0, exports.pushToGTMDataLayer)(gtmData);
        },
        subscribe: function (newsLetterData) {
            exports.GTM.newsletter.setStatus(NewsLetterAction.success, newsLetterData);
        },
        clickToSignup: function (newsLetterData) {
            exports.GTM.newsletter.setStatus(NewsLetterAction.submit, newsLetterData);
        },
        open: function (newsLetterData) {
            exports.GTM.newsletter.setStatus(NewsLetterAction.open, newsLetterData);
        },
        abandon: function (newsLetterData) {
            exports.GTM.newsletter.setStatus(NewsLetterAction.abandon, newsLetterData);
        },
    },
    menu: function (clickEvent, item) {
        var menuLevel = item.menuLevel, url = item.url, parentNodePath = item.parentNodePath, newWindow = item.newWindow;
        if (!parentNodePath || !menuLevel || !url) {
            return;
        }
        var menuPath = parentNodePath.split('/');
        var gtmItem = tslib_1.__assign({ event: GTMEventEnum.MegaMenu, targetUrl: url, menuLevel: menuLevel, menuItem: menuPath[0] }, (!!menuPath[1] && { subItem: menuPath[1] }));
        if (!newWindow) {
            processUrlRedirection(gtmItem, clickEvent, url);
        }
        (0, exports.pushToGTMDataLayer)(gtmItem);
    },
    zeroLevelMenu: function (clickEvent, item) {
        var url = item.url, newWindow = item.newWindow, caption = item.caption, type = item.type, menuLevel = item.menuLevel, nodeName = item.nodeName;
        if (type !== 'zeroLevel' || !url) {
            return;
        }
        var gtmItem = {
            event: GTMEventEnum.MegaMenu,
            menuItem: nodeName ? nodeName : caption,
            targetUrl: url,
            menuLevel: menuLevel,
        };
        if (!newWindow) {
            processUrlRedirection(gtmItem, clickEvent, url);
        }
        (0, exports.pushToGTMDataLayer)(gtmItem);
    },
    search: function (data) {
        var gtmData = {
            event: GTMEventEnum.Search,
            search_id: data.sessionId,
            search_keyword_query: data.searchQuery || '',
            search_refinement: data.refinement,
            search_result_number: data.resultsCount,
            search_suggestion: data.suggestion || false,
        };
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    navigation: function (data, callBack) {
        var gtmData = {
            event: GTMEventEnum.Navigation,
            linkType: data.linkType,
            linkUrl: data.linkUrl,
        };
        if (callBack) {
            gtmData.eventCallback = callBack;
            setTimeout(callBack, 1000);
        }
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    tileListItem: function (data, callBack) {
        var gtmData = {
            event: tileListEventMapping[data.tileListType],
            clickUrl: data.clickUrl,
            linkPosition: data.linkPosition,
            linkPage: data.linkPage,
            NumberOfResults: data.numberOfResults,
        };
        var isCalled = false;
        if (callBack) {
            var innerCallBack = function () {
                if (!isCalled) {
                    callBack();
                    isCalled = true;
                }
            };
            gtmData.eventCallback = innerCallBack;
            setTimeout(innerCallBack, 1000);
        }
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    productTabs: function (tabId) {
        var gtmData = {
            event: GTMEventEnum.ProductPageTabClick,
            productPageTab: tabId,
        };
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    socialLinks: function (data) {
        var gtmData = {
            event: GTMEventEnum.Social,
            socialChannel: data.channel,
            socialLink: data.link,
        };
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    contactsListLocationFinder: function (fieldValue) {
        var gtmData = {
            event: GTMEventEnum.ContactsListLocationFinderChange,
            input: fieldValue,
        };
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    contactsListItem: function (companyName) {
        var gtmData = {
            event: GTMEventEnum.ContactListItemClick,
            companyName: companyName,
        };
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    contactsListFilter: function (filterData) {
        var gtmData = {
            event: GTMEventEnum.Filter,
            filterCategory: filterData.filterCategory,
            filterOptions: filterData.filterOptions,
        };
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    contactDetailsDialClick: function (companyName) {
        var gtmData = {
            event: GTMEventEnum.ContactDetailsDialClick,
            companyName: companyName,
        };
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    contactDetailsCustomAttributesClick: function (companyName) {
        var gtmData = {
            event: GTMEventEnum.ContactDetailsCustomAttributesClick,
            companyName: companyName,
        };
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    contactFormOpen: function (contactFormData) {
        var gtmData = tslib_1.__assign({ event: GTMEventEnum.ContactFormOpen }, contactFormData);
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    contactFormLoadError: function (companyName) {
        var gtmData = {
            event: GTMEventEnum.ContactFormLoadError,
            companyName: companyName,
        };
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    webAnalytics: {
        pushCommonContext: function (commonData) {
            var commonContext = {
                language: commonData.language || '',
                user_id: commonData.user_id || '',
            };
            (0, exports.pushToGTMDataLayer)({ commonContext: commonContext });
        },
        pushPageContext: function (pageData) {
            var pageContext = {
                business_unit: pageData.business_unit || [],
                category: pageData.category || [],
                description: pageData.description || '',
                image_link: pageData.image_link || '',
                market: pageData.market || [],
                name: pageData.name || '',
                type: pageData.type || '',
                unique_id: pageData.unique_id || '',
                url: pageData.url || '',
            };
            (0, exports.pushToGTMDataLayer)({ pageContext: pageContext });
        },
        pushProductContext: function (_productData) {
            var productContext = {};
            (0, exports.pushToGTMDataLayer)({ productContext: productContext });
        },
    },
    iframeYoutubeVideo: function (data) {
        var gtmData = {
            event: GTMEventEnum.YoutubeVideo,
            videoName: data.videoTitle,
            videoAction: data.videoStatus,
            videoProgress: data.videoProgress,
        };
        (0, exports.pushToGTMDataLayer)(gtmData);
    },
    login: function (userId) {
        (0, exports.pushToGTMDataLayer)({ analytics_user_id: userId });
    },
};
